import React from 'react'
import Link from 'gatsby-link'
import {ThemeProvider} from 'styled-components'

import Flash from 'react-icons/lib/md/flash-on'
import Bulb from 'react-icons/lib/md/lightbulb-outline'
import Restore from 'react-icons/lib/md/import-contacts'
import Arrow from 'react-icons/lib/md/keyboard-arrow-right'

import Dienstplan from '../components/dienstplan'
import Header from '../components/header'
import Feature from '../components/feature'
import Button from '../components/button'

import Image from '../static/overtime.svg'
import TelegramIcon from '../static/telegram.svg'

const TrackerPage = () => (
  <ThemeProvider
    theme={{
      color: '#4a79ff'
    }}
  >
    <div>
      <Header
        title="Überstunden Tracker"
        phrase="Einfach Überstunden speichern"
        image={{
          src: Image
        }}
      >
        Was gibt es Schlimmeres als Überstunden? Sie zu verlieren, weil man sie
        nicht dokumentiert hat. Mit diesem Telegram Bot kannst du dem ein Ende
        setzen.
      </Header>

      <a target="_blank" href="https://t.me/ZiviBot">
        <Button>
          Telegram Bot starten <Arrow size={24} />
        </Button>
      </a>
      <Feature title="Schnell wie nie" icon={<Flash />}>
        Sende einfach die Anzahl an Überstunden und sie werden sofort
        gespeichert. Mithilfe der Quickbuttons ist das mit nur einem Knopfdruck
        möglich.
      </Feature>
      <Feature title="Smart" icon={<Bulb />}>
        Du musst nicht wissen, welches Datum heute ist. Auch das Zusammenrechnen
        deiner Überstunden kannst du dir in Zukunft sparen.
      </Feature>
      <Feature title="Jederzeit abrufbar" icon={<Restore />}>
        Erhalte eine Liste aller Überstunden der letzen 2 Monate.
      </Feature>
    </div>
  </ThemeProvider>
)

export default TrackerPage



// WEBPACK FOOTER //
// ./src/pages/tracker.js